import type { BootstrapData } from '@/app/(app)/context/BootstrapContext'
import { getDashboardDefaultDateRange } from '@/lib/dashboard/dateRange'
import { BUSINESS_TIMEZONE } from '@/lib/timezone'

/**
 * Instant bootstrap snapshot for the standalone portal (cookie auth, no Shopify host).
 * planResolution `unknown` lets FeatureGate render real UI while /api/bootstrap loads;
 * billingActive true avoids a flash redirect until the server responds.
 */
export function createPortalOptimisticBootstrap(): BootstrapData {
  const { from, to } = getDashboardDefaultDateRange()
  return {
    sessionReady: true,
    billingActive: true,
    plan: {
      planName: '…',
      status: 'ACTIVE',
      baseOrderLimit: 0,
      currentPeriodEnd: null,
      isCustom: false,
    },
    planNormalized: 'free',
    planResolution: 'unknown',
    features: {},
    usage: null,
    limits: { allowed: 0 },
    dashboard: null,
    dashboardDefaultRange: { from, to, timeZone: BUSINESS_TIMEZONE },
    adminAllowed: true,
  }
}
